import {Alert, AutoComplete, Button, Input, Modal, Select, Space, Typography, Upload, UploadProps} from "antd";
import React, {useEffect, useRef, useState} from "react";
import Dragable, {DraggableData, DraggableEvent} from "react-draggable";
import {userAPI} from "../../services/UserService";
import '../ModalStyles.scss';
import {UserModel} from "../../models/UserModel";
import {equipmentAPI} from "../../services/EquipmentService";
import {ObjectModel} from "../../models/ObjectModel";
import {PlusOutlined} from "@ant-design/icons";
import {EquipmentModel} from "../../models/EquipmentModel";
import imageCompression from 'browser-image-compression';
import {host, port, secure} from "../../config/config";

const {Text} = Typography;

type ModalProps = {
    infoNotification: Function,
    errorNotification: Function,
    setVisible: Function,
    getTasks: Function,
}

export const CreateTaskModal = (props: ModalProps) => {
    const [getUsersRequest, {
        data: dataGetUsersRequest,
        isLoading: isGettingUsersInProcess
    }] = userAPI.useGetUsersMutation();
    const [getEquipmentsRequest, {
        data: dataGetEquipmentsRequest,
        isLoading: isGettingEquipmentsInProcess,
    }] = equipmentAPI.useGetEquipmentsByObjectIdMutation();
    // Draggable settings
    const [disabled, setDisabled] = useState<boolean>(false);
    const [bounds, setBounds] = useState({left: 0, top: 0, bottom: 0, right: 0});
    const draggableRef = useRef<HTMLDivElement>(null);
    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const {clientWidth, clientHeight} = window.document.documentElement;
        const targetRect = draggableRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top - uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        })
    }
    // End of dnd
    const [modalWidth,] = useState<number>(600);
    const [selectedUser, setSelectedUser] = useState<string>('');
    const [selectedObject, setSelectedObject] = useState<string>('');
    const [selectedEquipment, setSelectedEquipment] = useState<string>('');
    const [title, setTitle] = useState<string>();
    const [description, setDescription] = useState<string>();
    const [photos, setPhotos] = useState<any>();
    const [compressedPhotos, setCompressedPhotos] = useState<any[]>([]);
    const [errors, setErrors] = useState<string[]>([]);
    const [isSuccessCreateTask, setIsSuccessCreateTask] = useState<boolean>(false);
    const [isLoadingCreateTaskRequest, setIsLoadingCreateTaskRequest] = useState<boolean>(false);
    useEffect(() => {
        getUsersRequest();
    }, []);
    useEffect(() => {
        if (isSuccessCreateTask) {
            props.infoNotification("Заявка создана")
            props.getTasks()
            props.setVisible(false)
        }
    }, [isSuccessCreateTask]);
    useEffect(() => {
        if (!selectedUser) {
            setSelectedObject('');
            setSelectedEquipment('');
        }
    }, [selectedUser])
    useEffect(() => {
        if (selectedObject)
            getEquipmentsRequest(selectedObject)
    }, [selectedObject])
    useEffect(() => {
        if (compressedPhotos.length === photos?.fileList?.length)
            createTaskHandler()
    }, [compressedPhotos])
    const createTaskHandler = () => {
        if (selectedObject && selectedEquipment && title) {
            setErrors([])
            let myHeaders = new Headers();
            myHeaders.append("authorization", `Bearer ${localStorage.getItem('token')}`);

            let formData = new FormData();
            formData.append("creator", selectedUser);
            formData.append("object", selectedObject);
            formData.append("equipment", selectedEquipment);
            formData.append("title", title);
            formData.append("description", description ?? "");
            if (compressedPhotos) {
                compressedPhotos.map((file: any, i:any) => {
                    formData.append(`photo${i}`, file, `photo-${i}.png`);
                })
            }
            let requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formData,
                redirect: 'follow'
            };
            setIsLoadingCreateTaskRequest(true)
            //@ts-ignore
            fetch(`${secure}://${host}${port}/tasks/createByAdmin`, requestOptions)
                .then(response => {
                    setIsLoadingCreateTaskRequest(false)
                })
                .then(result => {
                        setIsSuccessCreateTask(true);
                })
                .catch(error => {
                    setIsLoadingCreateTaskRequest(false)
                    setErrors([error.toString()])
                });
        } else {
            setIsLoadingCreateTaskRequest(false)
            setErrors(['Некоторые поля не заполнены'])
        }
    };
    const compressImage = () => {
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920
        }
        if (photos) {
            if (photos.fileList) {
                photos.fileList.map((file: any, i: any) => {
                    const compressedFile = imageCompression(file.originFileObj, options);
                    compressedFile.then((success) => {
                        setCompressedPhotos(prev => prev.concat(success))
                    })
                })
            }
        } else {
            createTaskHandler();
        }
    }
    const propsUpload: UploadProps = {
        beforeUpload(file) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    const img = document.createElement('img');
                    img.src = reader.result as string;
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = img.naturalWidth;
                        canvas.height = img.naturalHeight;
                        const ctx = canvas.getContext('2d')!;
                        ctx.drawImage(img, 0, 0);
                        ctx.fillStyle = 'red';
                        ctx.textBaseline = 'middle';
                        ctx.font = '33px Arial';
                        ctx.fillText('Ant Design', 20, 20);
                        canvas.toBlob((result) => resolve(result as any));
                    };
                };
            });
        },
    };
    const uploadButton = (
        <div>
            <PlusOutlined/>
            <div style={{marginTop: 8}}>Фото</div>
        </div>
    );
    return (
        <Modal
            title={'Создание заявки'}
            centered={true}
            open={true}
            footer={[]}
            modalRender={(modal) => (
                // @ts-ignore
                <Dragable
                    disabled={disabled}
                    bounds={bounds}
                    onStart={(event, uiData) => onStart(event, uiData)}
                >
                    <div ref={draggableRef}>{modal}</div>
                </Dragable>
            )}
            width={modalWidth}
            onCancel={() => props.setVisible(false)}
        >
            <div className="modalFlex">
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Выбор пользователя</Text>
                    <Select
                        loading={isGettingUsersInProcess}
                        allowClear
                        disabled={isGettingUsersInProcess}
                        value={selectedUser}
                        onChange={setSelectedUser}
                        style={{width: '100%'}}
                        options={dataGetUsersRequest ? dataGetUsersRequest.map((item: UserModel) => ({
                            value: item.id,
                            label: `${item.surname} ${item.name} ${item.secondName}`,
                        })) : []}
                    />
                </div>

                <Space direction="vertical" size="middle" style={{display: 'flex'}}>
                    <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}>
                        <Text style={{fontFamily: 'Roboto'}}>Объект</Text>
                        <Select
                            allowClear={true}
                            disabled={selectedUser === ''}
                            options={dataGetUsersRequest ? dataGetUsersRequest.find((item: UserModel) => item?.id as unknown as string === selectedUser)?.objects.map((obj: ObjectModel) => ({
                                value: obj.id,
                                label: obj.filialAndObj
                            })) : []}
                            style={{width: '100%'}}
                            onChange={setSelectedObject}
                            value={selectedObject}
                            notFoundContent={'Объект не найден'}
                        />
                    </div>
                    <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}>
                        <Text style={{fontFamily: 'Roboto'}}>Наименование техники/инвентарник</Text>
                        <AutoComplete
                            disabled={selectedUser === '' || selectedObject === '' || isGettingEquipmentsInProcess}
                            value={selectedEquipment}
                            onChange={setSelectedEquipment}
                            options={dataGetEquipmentsRequest ? dataGetEquipmentsRequest.map((eq: EquipmentModel) => ({
                                value: `${eq.name}#${eq.code}`
                            })) : []}
                            style={{width: '100%'}}
                            onSelect={setSelectedEquipment}
                            filterOption={(inputValue, option) => {
                                let opt = option!.value as unknown as string
                                return opt?.toUpperCase()?.indexOf(inputValue?.toUpperCase()) !== -1
                            }
                            }
                            notFoundContent={'Оборудование не найдено'}
                        />
                    </div>
                    <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}>
                        <Text style={{fontFamily: 'Roboto'}}>Заявленная неисправность</Text>
                        <Input value={title} onChange={(e) => setTitle(e.target.value)}/>
                    </div>
                    <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}>
                        <Text style={{fontFamily: 'Roboto'}}>Описание неисправности</Text>
                        <Input value={description} onChange={(e) => setDescription(e.target.value)}/>
                    </div>
                    <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                         style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                        <Upload style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}
                                multiple accept={'image/png, image/jpeg'}
                                onChange={(e) => setPhotos(e)}
                                maxCount={3}
                                listType="picture-card"
                                {...propsUpload}
                        >
                            {photos?.length >= 3 ? null : uploadButton}
                        </Upload>
                        {errors.map((error: string) => {
                            return (
                                <Alert style={{width: '100%', marginTop: '20px'}} message={error}
                                       type="error"/>
                            )
                        })}
                    </div>
                </Space>

                <div style={{marginTop: '20px'}} onMouseOver={() => setDisabled(true)}
                     onMouseLeave={() => setDisabled(false)}
                     className="modalButtons">
                    <Button disabled={isLoadingCreateTaskRequest} onClick={() => compressImage()}>Создать</Button>
                    <Button onClick={() => props.setVisible(false)}>Отменить</Button>
                </div>
            </div>
        </Modal>
    )
}